import React from 'react';
import Mtyp from '@mui/material/Typography';


const h6Style = {
	'&.MuiTypography-h6': {
		marginTop: 2,
		fontWeight: '500',
		fontSize: 16,
		borderBottom: '1px solid grey',
	},
};

const Typography = ({ children = '', errorMessage, ...props }) => {
	let text = children;
	if (children && children.includes('\n')) {
		const parts = children.split('\n');
		text = parts.reduce((acc, part, index) => {
			const partComponent = <span>{part}</span>;
			if (index === parts.length - 1) {
				return [...acc, partComponent];
			}

			return [...acc, partComponent, <br key='br' />];
		}, []);
	}
	return <Mtyp sx={{ marginBottom: 2, ...h6Style }} {...props}>{text}</Mtyp>;
};

Typography.type = 'Typography';
Typography.spec = [{
	name: 'Typography',
	key: 'title',
	icon: 'Bold',
	title: 'Title',
	category: 'layout',
	defaultProperties: {
		variant: 'h6',
	},
	translatable: ['children'],
	fields: [{
		type: 'TextField',
		label: 'Title text',
		name: 'children',
		placeholder: 'Body Text',
	}],
}, {
	name: 'Typography',
	key: 'body-text',
	icon: 'AlignLeft',
	title: 'Paragraph',
	category: 'layout',
	translatable: ['children'],
	defaultProperties: {
		variant: 'body1',
	},
	fields: [{
		type: 'TextArea',
		label: 'Text',
		name: 'children',
		placeholder: 'Body Text',
	}],
}];
export default Typography;